import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import AnnouncementButton from '../parts/AnnouncementsButton';
import PupilCard from '../parts/PupilCard';
import AnnouncementCard from '../parts/AnnouncementCard';
import AbstractDashboardPage from './AbstractDashboardPage';
import { appColours } from '../../helpers';
import { setData } from '../../actions/index';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import ParentVerifyEmail from '../parts/ParentVerifyEmail';

const colours = appColours();
const styles = theme => ({
  sectionHeading: {
    fontSize: 32,
    marginBottom: 24,
  },
  noPupilsAlert: {
    fontSize: 24,
    padding: 20,
    backgroundColor: '#FF7171',
    color: '#ffffff',
  },
});


const mapStateToProps = state => {
  return {
    user: state.user,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setData: (data, type) => dispatch(setData(data, type)),
  };
}

class DesktopDashboardPage extends AbstractDashboardPage {
  render() {
    const {
      isLoading,
      isLoaded,
      pupils,
      announcements,
    } = this.state;
    const {
      t,
      classes,
      user
    } = this.props;

    let finalAnnouncements = announcements.filter(
      announcement => announcement.state !== 'dismissed',
    );

    return (
      <div className="desktop-dashboard-page">
        {isLoading && !isLoaded && (
          <CircularProgress />
        )}
        {!isLoading && isLoaded && user.isEmailVerified && pupils.length === 0 && (
          <div className={classes.noPupilsAlert}>
            {t('There are currently no pupils linked to your account. Please contact your school to request a new access code.')}
          </div>
        )}
        {!isLoading && isLoaded && !user.isEmailVerified && (
          <ParentVerifyEmail
            onClose={() => { this.updateData(); }}
            useSuspense={false}
          />
        )}
        {isLoaded && user.isEmailVerified && finalAnnouncements.length > 0 && (
          <AnnouncementButton
            announcements={finalAnnouncements}
            useSuspense={false}
          />
        )}
        {isLoaded && user.isEmailVerified && pupils.length > 0 && (
          <Grid container spacing={4}>
            {pupils.map((pupil, index) => {
              const colourIndex = index % colours.length;
              return (
                <Grid item key={index} xs={6}>
                  <PupilCard
                    key={pupil.id}
                    pupil={pupil}
                    colourIndex={colourIndex}
                    useSuspense={false}
                  />
                </Grid>
              );
            })}
          </Grid>
        )}
        {isLoaded && user.isEmailVerified && announcements.length > 0 && (
          <>
            <h3>Announcements</h3>
            {finalAnnouncements.map((announcement) => {
              if (
                announcement.state === 'dismissed'
                && announcement.sticky === 'no'
              ) {
                return;
              }

              return (
                <AnnouncementCard
                  key={announcement.id}
                  announcement={announcement}
                  showForWhichPupils
                  useSuspense={false}
                />
              );
            })}
          </>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
    withStyles(styles)(withSnackbar(withTranslation()(DesktopDashboardPage)))
);
